export const TRANSLATOR = {
    "Group1A1" : "Rectangle",
    "Group1A2" : "Radius Corner Rectangle",
    "Group1B1" : "Circle",
    "Group1B2" : "Oblong",
    "Group1C" : "Triangle",
    "Group2A1" : "Ellipse",
    "Group2A2" : "Bowtie",
    "Group3" : "Chamfered Corner",
    "Group4" : "V Notch/Corner Notch",
    "Group5" : "Mitered Notch - 5",
    "Group6": "Radius Notch - 6",
    "Group7A": "Small Rectangle",
    "Group7B": "Small Square",
    "Group7C": "Small Obround",
    "Group8": "D-Sub Connector",
    "Group9": "Kiss-Cut Tab",
    "Group10" : "C-Spacer",
    "Group11": "Pac-Man",
    "Group12A": "Double D",
    "Group12B": "Cross-Hair",
    "Group13": "Circuit Tail",
    "Group14": "Knifed Cavity",
    "Group15": "Ladder",
    "Group16": "Freehand",
    "Group17": "Radius Notch - 17",
    "GroupS1": "Retainer with 1 Vent",
    "GroupS2": "Retainer with 2 Vents",
    "GroupS3": "Retainer with 3 Vents",
    "GroupS4": "Retainer with 4 Vents",
};

export function translate(groupName: string) {
    return TRANSLATOR[groupName] ?? groupName;
}
